import React from "react";
import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormHelperText,
} from "@mui/material";
import TickCircle from "../../Components/assets/Images/tick-circle.svg";
import EmptyCircle from "../../Components/assets/Images/TickEmptyCircle.svg";
import styles from "./Selectdropdown.module.scss";

interface Props {
  LabelName: string;
  menuItems: any;
  name: any;
  value: any;
  handleChange: any;
  error: any;
  helperText: any;
  setOthers?: any;
  disabled?: any;
  onBlur?: any;
}

const CommonRadioGroup: React.FC<Props> = ({
  LabelName,
  menuItems,
  name,
  value,
  handleChange,
  error,
  helperText,
  setOthers,
  disabled,
  onBlur,
}) => {
  // console.log("value", value);
  return (
    <FormControl error={error}>
      <RadioGroup
        row
        name={name}
        value={value?.value || ""}
        onChange={(e) => {
          const selected = menuItems.find(
            (item: any) => item.value === e.target.value,
          );

          if (setOthers) {
            setOthers(selected);
          }

          handleChange({
            target: {
              name,
              value: selected,
            },
          });
        }}
        onBlur={onBlur}
        sx={{
          gap: "32px",
          marginLeft: "25px",
        }}
      >
        {menuItems.map((a: any, index: number) => (
          <FormControlLabel
            key={index}
            value={a.value}
            disabled={disabled}
            control={
              <Radio
                icon={<img src={EmptyCircle} alt="unselected" />}
                checkedIcon={<img src={TickCircle} alt="selected" />}
                disableFocusRipple
                disableTouchRipple
                disableRipple
                sx={{
                  width: "20px",
                  height: "20px",
                }}
              />
            }
            label={<div className={styles.radioLabel}>{a.value}</div>}
          />
        ))}
      </RadioGroup>

      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default CommonRadioGroup;
